export default __webpack_public_path__ + "static/media/node.d2c1ab99.png";